import React from 'react'
import styled from 'styled-components'
import SearchIcon from '@mui/icons-material/Search';
import Badge from '@mui/material/Badge';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import { Link } from 'react-router-dom';
import {mobile} from '../responsive'
import { display } from '@mui/system';
import {cart} from '../data'
import logo from '../assets/logo.jpeg'
const Container = styled.div`
    width:100%;
    height: 80px;
    background:black;
    opacity:0.5;
    position:fixed;
    top:0;
    z-index: 1;
   
`;
const Wrapper = styled.div`
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items:center;
  ${mobile({padding: "0px 20px"})}
`;

const Left = styled.div`
  
  flex:1;
  display:flex;
  align-items:center;
  ${mobile({display:"none"})}
`;

const Language = styled.span`
  font-size: 14px;
  cursor: pointer;
`;



const Input = styled.input`
  border: none;

`;

const Logo = styled.img`
  width:150px;
  height:150px;
  ${mobile({display:"none"})}
`;

const Center = styled.div`
  flex:1;
  text-align:center;
  ${mobile({display:"none"})}
`;

const Right = styled.div`
  flex:2;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  ${mobile({ justifycontent: "center" })}
`;

const MenuItem = styled.div`
  font-size: 14px;
  cursor:pointer;
  :hover{
    color:red;
  }
  margin-left: 25px;
  color:white;
  text-decoration:none;
  ${mobile({display:"none",})}
`;

const Navbar = () => {
  return (
    <Container>
      <Wrapper>
        <Left>
        <Logo src={logo}></Logo>
        </Left>
        <Center>
         
        </Center>
        <Right>
          <Link to="/Ecommerce-Website"><MenuItem>Home</MenuItem></Link>
          <Link to='/about'><MenuItem>About Us</MenuItem></Link>
          <Link to='/member'><MenuItem>Member Exclusive</MenuItem></Link>
          <Link to='/register'><MenuItem>Register</MenuItem></Link>
          <Link to='/login'><MenuItem>Sign In</MenuItem></Link>
         <Link to='/cart'> <MenuItem>
            <Badge badgeContent={cart.length} color="primary">
            <ShoppingCartOutlinedIcon  />
            </Badge>
          </MenuItem></Link>
        </Right>
      </Wrapper>
    </Container>
  )
}

export default Navbar